import React from 'react'
import { useIsQueryOwner } from '@/hooks'

import Box from '@mui/material/Box'

import { EmtChip, EmtIcon, EmtTypography, useMobile } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import { LightBox, TrueFalseContainer, TrueFalseItem } from './StyledComponents'
import { useEMTState } from '@/store'
import { MemberProfile } from '@/dataV3/User/MemberProfile'
import { AnimalProfile } from '@/dataV3/Animal/AnimalProfile'

type Props = React.PropsWithChildren<{
  profile:
    | Pick<MemberProfile, 'displayName' | 'memberOptions'>
    | Pick<AnimalProfile, 'displayName' | 'memberOptions' | 'animalOptions'>
  customerType?: string
}>

const Availabilities: React.FC<Props> = ({ profile, customerType }) => {
  const { t } = useTranslation('profile')
  const [isMobile, isTablet] = useMobile()
  const [, queryType] = useIsQueryOwner()

  const type = customerType || queryType

  const { disponibilityChoices } = useEMTState().configuration

  const entrusts = disponibilityChoices.filter((obj) => obj.slug === 'attention')[0]?.types
  const disponibilities = disponibilityChoices.filter((obj) => obj.slug === 'disponibility')[0]?.types

  // Use animalOptions if present, otherwise memberOptions
  const animalOptions = (profile as any).animalOptions
  const memberOptions = profile.memberOptions
  const displayName = profile.displayName
  const options = animalOptions ?? memberOptions

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile || isTablet ? 'column' : 'row', gap: '24px' }}>
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {t(`availabilities.disponibility.${type}`, {
            name: displayName,
          })}
        </EmtTypography>
        <TrueFalseContainer>
          {disponibilities &&
            disponibilities.map((disponibility, k) => (
              <TrueFalseItem key={k}>
                <EmtChip
                  color={options[disponibility.slug] ? 'successlight' : 'greylight'}
                  icon={options[disponibility.slug] ? <EmtIcon className="emt-tick" /> : <EmtIcon className="emt-x" />}
                />
                <EmtTypography variant="body2" color="greyGradient.450">
                  {disponibility.sentence[type === 'borrower' ? 'borrowerSentence' : 'ownerSentence'].profileSentence}
                </EmtTypography>
              </TrueFalseItem>
            ))}
        </TrueFalseContainer>
      </LightBox>
      <LightBox>
        <EmtTypography variant="h5" fontWeight={700}>
          {t(`availabilities.entrustTitle.${type}`, {
            name: displayName,
          })}
        </EmtTypography>

        <TrueFalseContainer>
          {entrusts &&
            entrusts.map((entrust, k) => (
              <TrueFalseItem key={k}>
                <EmtChip
                  color={options[entrust.slug] ? 'successlight' : 'greylight'}
                  icon={options[entrust.slug] ? <EmtIcon className="emt-tick" /> : <EmtIcon className="emt-x" />}
                />
                <EmtTypography variant="body2" color="greyGradient.450">
                  {entrust.sentence[type === 'borrower' ? 'borrowerSentence' : 'ownerSentence'].profileSentence}
                </EmtTypography>
              </TrueFalseItem>
            ))}
        </TrueFalseContainer>
      </LightBox>
    </Box>
  )
}

export default Availabilities
